import React from 'react';
import EditIcon from 'src/common/utils/TableColumnIcons/EditIcon';
import TrashIcon from 'src/common/utils/TableColumnIcons/TrashIcon';
import RepeatIcon from 'src/common/utils/TableColumnIcons/RepeatIcon';

export const ActionColumnFormat = (
	value,
	row,
	rowIndex,
	{ onDelete, onEdit, onStatus }
) => {
	return (
		<>
			<TrashIcon onClick={() => onDelete(row)} />
			<EditIcon
				onClick={() => onEdit(row)}
				color="light-primary"
				className={'ml-2'}
			/>
			<RepeatIcon
				onClick={() => onStatus(row)}
				tooltip="Cambiar estatus"
				color="info"
				className={'ml-2'}
			/>
		</>
	);
};
